module.exports = __webpack_public_path__ + "media/images/logo-mobile-2-134ea9c507a0da5c71b6b3097d2a4f57.svg";